import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'authorization/guards/auth-guard';
import { AccountCreateEntryPageGuard } from 'authorization/pages/azureb2c-create-account-entry/azureb2c-create-account-entry.routing.guard';
import { CreateAccountEntryResolverService } from 'authorization/pages/azureb2c-create-account-entry/azureb2c-create-account-entry.routing.resolver';
import { LoginEntryPageGuard } from 'authorization/pages/azureb2c-login-entry/azureb2c-login-entry.routing.guard';
import { LoginEntryResolverService } from 'authorization/pages/azureb2c-login-entry/azureb2c-login-entry.routing.resolver';
import { PinLoginPageGuard } from 'authorization/pages/pin-login/pin-login.router.guard';
import { HomeResolverService } from 'home/pages/home/home.routing.resolver';
import { NewsReadPageGuard } from 'news/pages/news-read/news-read.routing.guard';
import { SetPinCodeResolverService } from 'user-settings/components/set-pin-code/set-pin-code.routing.resolver';
import { PolicyViewPageGuard } from 'valuations/pages/policy-view/policy-view.routing.guard';
import { MessagePageGuard } from '../messages/pages/message/message.routing.guard';


const routes: Routes = [
    {
        path: '',
        redirectTo: 'landing',
        pathMatch: 'full'
    }, // redirect
    {
        path: 'landing',
        loadChildren: () => import('../authorization/pages/landing/landing.module').then(m => m.LandingPageModule)
    },
    {
        path: 'account-login',
        loadChildren: () => import('../authorization/pages/account-login/account-login.module').then(m => m.AccountLoginPageModule)
    },
    {
        path: 'azureb2c-login-entry',
        canActivate: [ LoginEntryPageGuard ],
        resolve: {
            loginEndResult: LoginEntryResolverService
        },
        loadChildren: () => import('../authorization/pages/azureb2c-login-entry/azureb2c-login-entry.module').then(m => m.AzureB2cEntryPageModule)
    },
    {
        path: 'azureb2c-create-account-entry',
        canActivate: [ AccountCreateEntryPageGuard ],
        resolve: {
            createAccountEndResult: CreateAccountEntryResolverService
        },
        loadChildren: () => import('../authorization/pages/azureb2c-create-account-entry/azureb2c-create-account-entry.module').then(m => m.AzureB2cCreateAccountEntryPageModule)
    },
    {
        path: 'pin-login',
        canActivate: [ PinLoginPageGuard ],
        loadChildren: () => import('../authorization/pages/pin-login/pin-login.module').then(m => m.PinLoginPageModule)
    },
    {
        path: 'set-pin',
        canActivate: [ AuthGuard, PinLoginPageGuard ],
        resolve: {
            result: SetPinCodeResolverService
        },
        loadChildren: () => import('../user-settings/components/set-pin-code/set-pin-code.module').then(m => m.SetPinCodePageModule)
    },
    {
        path: 'check-pin',
        canActivate: [ AuthGuard ],
        loadChildren: () => import('../authorization/pages/check-pin/check-pin.module').then(m => m.CheckPinPageModule)
    },
    {
        path: 'home/:sessionToken',
        canActivate: [ AuthGuard ],
        resolve: {
            result: HomeResolverService
        },
        loadChildren: () => import('../home/pages/home/home.module').then(m => m.HomePageModule)
    },
    {
        path: 'news/:id',
        canActivate: [ AuthGuard, NewsReadPageGuard ],
        runGuardsAndResolvers: 'always',
        loadChildren: () => import('../news/pages/news-read/news-read.module').then(m => m.NewsReadPageModule)
    },
    {
        path: 'advisor',
        canActivate: [ AuthGuard ],
        loadChildren: () => import('../advisors/pages/advisor-details/advisor-details.module').then(m => m.AdvisorDetailsPageModule)
    },
    {
        path: 'settings',
        canActivate: [ AuthGuard ],
        loadChildren: () => import('../user-settings/pages/settings/settings.module').then(m => m.SettingsPageModule)
    },
    {
        path: 'content',
        canActivate: [ AuthGuard ],
        loadChildren: () => import('../user-settings/pages/content/content.module').then(m => m.ContentPageModule)
    },
    {
        path: 'faq',
        canActivate: [ AuthGuard ],
        loadChildren: () => import('../user-settings/pages/frequently-asked-questions/frequently-asked-questions.module').then(m => m.FrequentlyAskedQuestionsPageModule)
    },
    {
        path: 'policy/:policy',
        canActivate: [ AuthGuard, PolicyViewPageGuard ],
        loadChildren: () => import('../valuations/pages/policy-view/policy-view.module').then(m => m.PolicyViewPageModule)
    },
    {
        path: 'message',
        canActivate: [MessagePageGuard],
        loadChildren: () => import('../messages/pages/message/message.module').then(m => m.MessagePageModule)
    },
    {
        path: '**',
        redirectTo: 'landing'
    },
];
@NgModule({
    imports: [
        RouterModule.forRoot(routes,
            {
                onSameUrlNavigation: 'reload'
            },
        )
    ],
    exports: [ RouterModule ]
})
export class AppRoutingModule { }

